import { Modal, Spinner } from 'native-base'
import * as React from 'react'

const LoadingView = ({ isOpen }: { isOpen: boolean }) => {
  return (
    <Modal isOpen={isOpen} background={'rgba(0,0,0,0)'}>
      <Spinner color="white" size={40} padding={2} />
    </Modal>
  )
}

export default LoadingView
